import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-privacy-content",
  templateUrl: "./privacy-content.component.html",
  styleUrls: ["./privacy-content.component.scss"],
})
export class PrivacyContentComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
